module.exports = __webpack_public_path__ + "static/media/Logo (1).faf91be3.svg";